/**
 * Blush: loads Afterpay's official on-site messaging script, but only when the page actually shows an
 * Afterpay message (<afterpay-placement> for Australia, <afterpay-modal> for the United States version),
 * both rendered by snippets/blush-afterpay.liquid.
 *
 * - Product pages and the cart page contain the message in the page itself, so the script loads straight away.
 * - Everywhere else the message only appears once the cart drawer is drawn with items in it, so a
 *   MutationObserver waits for the first message to be added and loads the script then.
 * - The Australian message re-draws itself when its data-amount changes. The United States message is plain
 *   server-rendered HTML, so it simply follows whatever the section renders. Its info icon opens Afterpay's own
 *   US explainer (afterpay-modal), which this file switches on with the `visible` attribute.
 */
const AFTERPAY_SRC = 'https://js.afterpay.com/afterpay-1.x.js';
const MESSAGE = 'afterpay-placement, afterpay-modal';

let loaded = false;

function loadAfterpay() {
  if (loaded) return;
  loaded = true;

  const script = document.createElement('script');
  script.src = AFTERPAY_SRC;
  script.async = true;
  document.head.appendChild(script);
}

if (document.querySelector(MESSAGE)) {
  loadAfterpay();
} else {
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node instanceof Element && (node.matches(MESSAGE) || node.querySelector(MESSAGE))) {
          observer.disconnect();
          loadAfterpay();
          return;
        }
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

document.addEventListener('click', (event) => {
  const trigger = event.target instanceof Element ? event.target.closest('[data-blush-afterpay-info]') : null;
  const modal = trigger?.parentElement?.querySelector('afterpay-modal');
  if (!modal) return;

  loadAfterpay();
  customElements.whenDefined('afterpay-modal').then(() => modal.setAttribute('visible', ''));
});
